module.exports = __webpack_public_path__ + "img/autorizar (1).441dbd33.png";